import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdminTable from '../AdminTable';
import AdminModalForm from '../AdminModalForm';
import { MODELS } from '../../../constants/admin/settings';
import {
    fetchList,
    deletePartners,
    fetchBulkSetEventsDependencies,
    bulkUpdateEvents
} from '../../../actions/admin/models/partners';
import { openModalFormWithData } from '../../../actions/admin/modal.forms';
import { BREADCRUMB } from '../../../constants/admin/breadcrumb';
import { withBreadcrumb } from '../../../components/admin/hocs/BreadcrumbWrapper';
import PartnersEventFilter from '../../../components/admin/forms/partners/PartnersEventFilter';
import { dataSelector, selectedSelector } from '../../../selectors/admin/tables';
import BulkSetEventsInputs from '../../../components/admin/lineup/BulkSetEventsInputs';

class Index extends Component {
    state = {
        modalModel: ''
    };

    _openBulkSetEventsModal = () => {
        const selectedPartnerIds = this.props.selection;
        const partnersData = this.props.partners || [];
        const selectedPartners = partnersData.filter(p => selectedPartnerIds.includes(p.id));

        const commonEventIds =
            selectedPartners.length > 0 && selectedPartners.every(p => p.eventIds && p.eventIds.length >= 0)
                ? selectedPartners
                      .map(p => p.eventIds || [])
                      .reduce((acc, ids) => acc.filter(id => ids.includes(id)), selectedPartners[0].eventIds || [])
                : [];

        this.setState({ modalModel: MODELS.BULK_SET_EVENTS });
        this.props.openModalFormWithData(MODELS.BULK_SET_EVENTS, { eventIds: commonEventIds });
    };

    _formatEvents = (_value, partner) => {
        const ids = partner.eventIds || [];
        return ids.length ? `${ids.length} event${ids.length === 1 ? '' : 's'}` : '—';
    };

    render() {
        const contextId = this.props.contextId;
        return (
            <React.Fragment>
                <AdminTable
                    AdvancedSearchForm={PartnersEventFilter}
                    enableSearch={true}
                    fetchDataFunction={this.props.fetchList}
                    model={MODELS.PARTNER}
                    deleteAction={this.props.deletePartners}
                    pagination={true}
                    selectionActions={['SET EVENTS']}
                    selectionFunctions={[this._openBulkSetEventsModal]}
                    transformFunctions={{ eventIds: this._formatEvents }}
                />
                {this.state.modalModel === MODELS.BULK_SET_EVENTS ? (
                    <AdminModalForm
                        title={`Set Events for ${this.props.selection.length} Partner${
                            this.props.selection.length === 1 ? '' : 's'
                        }`}
                        fields={BulkSetEventsInputs}
                        fetchDependencies={() => this.props.fetchBulkSetEventsDependencies(contextId)}
                        staticData={{
                            selectedPartners: (this.props.partners || []).filter(p =>
                                this.props.selection.includes(p.id)
                            )
                        }}
                        model={MODELS.BULK_SET_EVENTS}
                        createAction={data => this.props.bulkUpdateEvents(data, this.props.selection)}
                        confirmLabel="Save"
                    />
                ) : null}
            </React.Fragment>
        );
    }
}

const tableProps = { tableIndex: 0 };

const mapStateToProps = state => ({
    selection: selectedSelector(state, tableProps),
    partners: dataSelector(state, tableProps)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            fetchList,
            deletePartners,
            openModalFormWithData,
            fetchBulkSetEventsDependencies,
            bulkUpdateEvents
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(withBreadcrumb(Index, () => [BREADCRUMB.PARTNERS]));
